<!-- Custom Header (matching prompt page style) -->
<header class="metrics-custom-header">
   <div class="metrics-back-button">
    <button (click)="goBack()" class="back-btn">
      <span class="back-arrow">←</span> 
    </button>
  </div>
  <h1 style="font-size: 2.4vh; font-weight: 600; color: white; margin:0; flex: 1;">
    Wells Lookback and Performance Insights
  </h1>
</header>

<div class="metrics-wrapper">
  <!-- Back Button -->
  <!-- <div class="metrics-back-button">
    <button (click)="goBack()" class="back-btn">
      <span class="back-arrow">←</span> Back to Prompt
    </button>
  </div> -->

  <!-- Header with Date Range -->
  <div class="metrics-header-row">
    <div class="metrics-header">
      <h1 class="page-title">User Metrics Dashboard</h1>
      <p class="page-subtitle">Connected to the usage analytics API to track adoption.</p>
    </div>

    <!-- Date Range Section (Top Right) -->
    <div class="date-range-compact">
      <div class="date-inputs-compact">
        <div class="date-group-compact">
          <label for="fromDate" class="date-label-compact">From</label>
          <input
            type="date"
            id="fromDate"
            [(ngModel)]="fromDate"
            name="fromDate"
            class="date-input-compact"
            [attr.max]="todayDate"
          />
        </div>

        <div class="date-group-compact">
          <label for="toDate" class="date-label-compact">To</label>
          <input
            type="date"
            id="toDate"
            [(ngModel)]="toDate"
            name="toDate"
            class="date-input-compact"
            [attr.min]="fromDate"
            [attr.max]="todayDate"
          />
        </div>

        <button
          type="button"
          (click)="applyDateRange()"
          class="apply-button-compact">
          Apply
        </button>
      </div>

      <!-- <div class="last-updated-compact">
        Last updated: {{ toDate | date: 'MMM d, yyyy, h:mm a' }}
      </div> -->
    </div>
  </div>

  <!-- Error Message for Date Range Validation -->
  <div *ngIf="error" class="error-banner">
    <div class="error-content">
      <span class="error-icon">⚠️</span>
      <p class="error-text">{{ error }}</p>
      <button (click)="error = null" class="error-close">✕</button>
    </div>
  </div>

  <!-- KPI Cards - Show only when data is loaded -->
  <div *ngIf="!isLoading && kpiCards.length > 0" class="kpi-cards-container">
    <div 
      *ngFor="let card of kpiCards; let i = index" 
      class="kpi-card"
      (click)="openModal(i === 0 ? 'users' : i === 1 ? 'questions' : i === 2 ? 'feedback' : null)"
      [style.cursor]="i < 3 ? 'pointer' : 'default'"
      [style.opacity]="i < 3 ? 1 : 0.8">
      <div class="card-icon" [attr.data-icon]="card.icon"></div>
      <div class="card-content">
        <h3 class="card-title">{{ card.title }}</h3>
        <p class="card-value">{{ card.value }}</p>
        <p class="card-description">{{ card.description }}</p>
      </div>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="loading-spinner-container">
    <div class="loading-spinner">
      <img src="assets/images/spinner.png" alt="Loading..." class="spinner-image" />
      <p>Loading metrics...</p>
    </div>
  </div>

  <!-- Graphs Section (Row Layout) -->
  <div class="graphs-row-container">
    <!-- Daily Active Users Chart - Full Width -->
    <div class="graph-section graph-item full-width">
      <div class="graph-header">
        <h2 class="graph-title">Daily Active Users</h2>
        <p class="graph-subtitle">User activity trend across the selected period.</p>
      </div>
      <div class="graph-box">
        <div *ngIf="isLoading" class="loading-message">
          <p>Loading chart...</p>
        </div>
        <div *ngIf="!isLoading && graphData.length > 0">
          <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="dailyActiveUsersChartOptions"
            style="width: 100%; height: 100%;">
          </highcharts-chart>
        </div>
        <div *ngIf="!isLoading && graphData.length === 0" class="no-data-message">
          <p>No data available for the selected period</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Overlay -->
<div *ngIf="activeModal" class="modal-overlay" (click)="closeModal()"></div>

<!-- Active Users Modal -->
<div *ngIf="activeModal === 'users'" class="modal-container">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">Active Users <span class="modal-count">{{ activeUsers.length }}</span></h2>
      <div class="modal-actions">
        <div class="modal-search">
          <input 
            type="text" 
            [(ngModel)]="searchQuery" 
            placeholder="Search by name..." 
            class="search-input"
          />
        </div>
        <button (click)="downloadData()" class="modal-btn-icon" title="Download">
          <img src="assets/images/download.png" alt="Download" class="download-icon" />
        </button>
        <button (click)="closeModal()" class="modal-btn-close">✕</button>
      </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="modalLoading" class="modal-loading">
      <div class="loading-spinner-container">
        <div class="loading-spinner">
          <img src="assets/images/spinner.png" alt="Loading..." class="spinner-image" />
          <p>Loading active users...</p>
        </div>
      </div>
    </div>

    <!-- Error state -->
    <div *ngIf="modalError" class="modal-error">
      <p>{{ modalError }}</p>
    </div>

    <!-- Modal Body - Table -->
    <div *ngIf="!modalLoading && !modalError" class="modal-body">
      <table class="users-table">
        <thead>
          <tr>
            <th class="col-initial"></th>
            <th class="col-name">USER NAME</th>
            <th class="col-email">USER MAIL</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of getPaginatedActiveUsers()" class="user-row">
            <td class="col-initial">
              <div class="user-avatar">{{ user.name.split(',')[0].substring(0, 2).toUpperCase() }}</div>
            </td>
            <td class="col-name">{{ user.name }}</td>
            <td class="col-email">{{ user.email }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal Footer - Pagination -->
    <div class="modal-footer">
      <p class="pagination-info">Showing {{ (currentPage - 1) * itemsPerPage + 1 }}-{{ Math.min(currentPage * itemsPerPage, getFilteredActiveUsers().length) }} of {{ getFilteredActiveUsers().length }}</p>
      <div class="pagination-controls">
        <button 
          (click)="previousPage()" 
          [disabled]="currentPage === 1"
          class="pagination-btn">
          ←
        </button>
        <span class="pagination-number">{{ currentPage }} / {{ getTotalPages() }}</span>
        <button 
          (click)="nextPage()" 
          [disabled]="currentPage === getTotalPages()"
          class="pagination-btn">
          →
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Questions Asked Modal -->
<div *ngIf="activeModal === 'questions'" class="modal-container">
  <div class="modal-content large" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">Questions Asked <span class="modal-count" *ngIf="!modalLoading; else loadingCount">{{ totalQuestionsCount }}</span><ng-template #loadingCount><span class="modal-count">...</span></ng-template></h2>
      <div class="modal-actions">
        <div class="modal-filters">
          <app-multi-select-dropdown 
            [options]="getUsersDropdownOptions()"
            [selectedIds]="selectedUsers"
            (selectionChange)="onQuestionsUsersSelected($event)"
            placeholder="👤 All users"
            icon="👤">
          </app-multi-select-dropdown>
        </div>
        <button (click)="downloadData()" class="modal-btn-icon" title="Download">
          <img src="assets/images/download.png" alt="Download" class="download-icon" />
        </button>
        <button (click)="closeModal()" class="modal-btn-close">✕</button>
      </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="modalLoading" class="modal-loading">
      <div class="loading-spinner-container">
        <div class="loading-spinner">
          <img src="assets/images/spinner.png" alt="Loading..." class="spinner-image" />
          <p>Loading questions...</p>
        </div>
      </div>
    </div>

    <!-- Error state -->
    <div *ngIf="modalError" class="modal-error">
      <p>{{ modalError }}</p>
    </div>

    <!-- Modal Body - Questions List -->
    <div *ngIf="!modalLoading && !modalError" class="modal-body questions-list">
      <div *ngFor="let q of questionsAsked; let i = index" class="question-card">
        <div class="question-number">#{{ (currentQuestionsPage - 1) * 15 + i + 1 }}</div>
        <div class="question-content">
          <p class="question-text">{{ q.content }}</p>
          <div class="question-meta">
            <span class="question-user">{{ q.name || q.email }}</span>
            <span class="question-timestamp">{{ formatTimestamp(q.timestamp) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer - Pagination -->
    <div class="modal-footer">
      <p class="pagination-info">Showing {{ (currentQuestionsPage - 1) * 15 + 1 }}-{{ Math.min(currentQuestionsPage * 15, totalQuestionsCount) }} of {{ totalQuestionsCount }} questions</p>
      <div class="pagination-controls">
        <button 
          (click)="previousQuestionsPage()" 
          [disabled]="currentQuestionsPage === 1"
          class="pagination-btn">
          ←
        </button>
        <span class="pagination-number">{{ currentQuestionsPage }} / {{ getTotalQuestionsPages() }}</span>
        <button 
          (click)="nextQuestionsPage()" 
          [disabled]="currentQuestionsPage === getTotalQuestionsPages()"
          class="pagination-btn">
          →
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Feedback Comments Modal -->
<div *ngIf="activeModal === 'feedback'" class="modal-container">
  <div class="modal-content large" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">Feedback <span class="modal-count" *ngIf="!modalLoading; else loadingCountFeedback">{{ totalFeedbackCount }}</span><ng-template #loadingCountFeedback><span class="modal-count">...</span></ng-template></h2>
      <div class="modal-actions">
        <div class="modal-filters">
          <app-multi-select-dropdown 
            [options]="getUsersDropdownOptions()"
            [selectedIds]="selectedUsers"
            (selectionChange)="onFeedbackUsersSelected($event)"
            placeholder="👤 All users"
            icon="👤">
          </app-multi-select-dropdown>
        </div>
        <div class="modal-filters">
          <app-multi-select-dropdown 
            [options]="getRatingsDropdownOptions()"
            [selectedIds]="selectedRatings"
            (selectionChange)="onFeedbackRatingsSelected($event)"
            placeholder="⭐ All ratings"
            icon="⭐">
          </app-multi-select-dropdown>
        </div>
        <button (click)="downloadData()" class="modal-btn-icon" title="Download">
          <img src="assets/images/download.png" alt="Download" class="download-icon" />
        </button>
        <button (click)="closeModal()" class="modal-btn-close">✕</button>
      </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="modalLoading" class="modal-loading">
      <div class="loading-spinner-container">
        <div class="loading-spinner">
          <img src="assets/images/spinner.png" alt="Loading..." class="spinner-image" />
          <p>Loading feedback...</p>
        </div>
      </div>
    </div>

    <!-- Error state -->
    <div *ngIf="modalError" class="modal-error">
      <p>{{ modalError }}</p>
    </div>

    <!-- Modal Body - Feedback List -->
    <div *ngIf="!modalLoading && !modalError" class="modal-body feedback-list">
      <div *ngFor="let feedback of feedbackComments; let i = index" 
           class="feedback-card"
           [class.feedback-like]="feedback.sentiment.toLowerCase() === 'like'"
           [class.feedback-dislike]="feedback.sentiment.toLowerCase() === 'dislike'">
        <div class="feedback-question-header">
          <strong>{{ feedback.question }}</strong>
          <button (click)="toggleAnswerVisibility(feedback.message_id)" 
                  class="answer-toggle-btn"
                  [class.expanded]="isAnswerVisible(feedback.message_id)"
                  title="Toggle answer visibility">
            {{ isAnswerVisible(feedback.message_id) ? '▼ Hide Answer' : '▶ View Answer' }}
          </button>
        </div>
        <div class="feedback-issue-type" *ngIf="feedback.issue_type">
          <span class="issue-label">Feedback On: {{ feedback.issue_type }}</span>
        </div>
        <div class="feedback-answer" *ngIf="isAnswerVisible(feedback.message_id)">
          <div class="answer-label">Answer:</div>
          <div class="answer-content">{{ feedback.answer }}</div>
        </div>
        <div class="feedback-comments">
          <em *ngIf="feedback.additional_comments">"{{ feedback.additional_comments }}"</em>
          <em *ngIf="!feedback.additional_comments" style="color: #9ca3af;">No comments</em>
        </div>
        <div class="feedback-footer">
          <div class="feedback-user-info">
            <span class="user-name">{{ feedback.name || feedback.email }}</span>
            <span class="feedback-time">{{ formatTimestamp(feedback.timestamp) }}</span>
          </div>
          <div class="feedback-rating">
            <span *ngFor="let star of getStarArray(feedback.response_rating)" class="star filled">★</span>
            <span *ngFor="let star of getEmptyStarArray(feedback.response_rating)" class="star empty">★</span>
          </div>
        </div>
        <div class="feedback-sentiment-footer" *ngIf="feedback.sentiment.toLowerCase() === 'like' || feedback.sentiment.toLowerCase() === 'dislike'">
          <span class="sentiment-label" 
                [class.sentiment-positive]="feedback.sentiment.toLowerCase() === 'like'" 
                [class.sentiment-negative]="feedback.sentiment.toLowerCase() === 'dislike'">
            {{ feedback.sentiment.toLowerCase() === 'like' ? 'Like' : 'Dislike' }}
          </span>
        </div>
      </div>

      <!-- No results message -->
      <div *ngIf="feedbackComments.length === 0" class="no-results">
        <p>No feedback found matching the selected filters.</p>
      </div>
    </div>

    <!-- Modal Footer - Pagination -->
    <div class="modal-footer">
      <p class="pagination-info">Showing {{ (currentFeedbackPage - 1) * 15 + 1 }}-{{ Math.min(currentFeedbackPage * 15, totalFeedbackCount) }} of {{ totalFeedbackCount }} feedback items</p>
      <div class="pagination-controls">
        <button 
          (click)="previousFeedbackPage()" 
          [disabled]="currentFeedbackPage === 1"
          class="pagination-btn">
          ←
        </button>
        <span class="pagination-number">{{ currentFeedbackPage }} / {{ getTotalFeedbackPages() }}</span>
        <button 
          (click)="nextFeedbackPage()" 
          [disabled]="currentFeedbackPage === getTotalFeedbackPages()"
          class="pagination-btn">
          →
        </button>
      </div>
    </div>
  </div>
</div>
